"use strict";
exports.__esModule = true;
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
exports["default"] = launchdarkly_react_client_sdk_1.withLDProvider;
//# sourceMappingURL=withFeatureFlags.js.map